// @flow

import { b2cPagesService } from '@clubmed/utils';

import { getFromLocalStorage, setInLocalStorage } from 'Client/local-storage-api';
import {
  SHOPPING_TRACKING,
  SHOPPING_LAST_VISITED_PRODUCTS,
  SHOPPING_LAST_VISITED_PRODUCTS_NUMBER,
} from 'Tracking/constants';

const {
  PAGE_TYPES: { RESORT, TOUR, CRUISE, RESORT_MICE },
} = b2cPagesService;

export function getLastVisitedProductIds(): string[] {
  const trackingShopping = getFromLocalStorage(SHOPPING_TRACKING);
  return trackingShopping ? trackingShopping[SHOPPING_LAST_VISITED_PRODUCTS] : [];
}

export function trackLastVisitedProducts(pageContext: PageContext, productId?: string) {
  if ([RESORT, TOUR, CRUISE, RESORT_MICE].includes(pageContext.pageType) && productId) {
    const seenProductIds = getLastVisitedProductIds()
      .filter(seenResortId => seenResortId !== productId)
      .slice(0, SHOPPING_LAST_VISITED_PRODUCTS_NUMBER - 1);

    setInLocalStorage(SHOPPING_TRACKING, {
      [SHOPPING_LAST_VISITED_PRODUCTS]: [productId, ...seenProductIds],
    });
  }
}
